<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('page-security') }}</h1>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
            </div>
        </v-flex>
        <!-- Filters -->
        <v-form class="flex xs12 mb-3" @submit.prevent="onFilter">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>
                        <!-- Role Filter -->
                        <v-flex md4 sm6 xs12>
                            <v-autocomplete :label="$t('role')"
                                            v-model="filters.role"
                                            :items="roleList"
                                            name="role"
                                            :item-text="getLabelByLang('enName', 'arName')"
                                            item-value="id"
                                            clearable
                                            v-validate="'required'"
                                            :data-vv-as="$t('role')"
                                            :error-messages="errors.collect('role')"></v-autocomplete>
                        </v-flex>

                        <!-- Sysyem Filter -->
                        <v-flex md3 sm6 xs12>
                            <v-autocomplete :label="$t('system')"
                                            v-model="filters.system"
                                            :items="systemList"
                                            name="system"
                                            :item-text="getLabelByLang('enLabel', 'arLabel')"
                                            item-value="code"
                                            clearable></v-autocomplete>
                        </v-flex>

                        <!-- Module Filter -->
                        <v-flex md3 sm6 xs12>
                            <v-autocomplete :label="$t('module')"
                                            v-model="filters.module"
                                            :items="modules"
                                            name="module"
                                            :item-text="getLabelByLang('enLabel', 'arLabel')"
                                            item-value="code"
                                            clearable></v-autocomplete>
                        </v-flex>

                        <!-- Page Filter -->
                        <v-flex md3 sm6 xs12>
                            <v-autocomplete :label="$t('page')"
                                            v-model="filters.page"
                                            :items="pages"
                                            name="page"
                                            :item-text="getLabelByLang('enLabel', 'arLabel')"
                                            item-value="code"
                                            clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('search') }}</v-btn>
                            <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                            <!--<v-checkbox class="d-inline-flex mx-2" :data-vv-as="$t('check-all')" :label="$t('check-all')" name="checkAll"></v-checkbox>-->
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-form>

        <!-- Actions Table -->
        <v-flex xs12 class="mb-3" >
            <v-data-table :loading="isLoading" :headers="actionsHeaders" :items="actions" class="elevation-1">
                <template slot="items" slot-scope="props">
                    <td>{{ getLabelByLang(props.item.pageENName, props.item.pageARName) }}</td>
                    <td>
                        <v-checkbox v-model="props.item.view"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.add"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.edit"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.delete"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.post"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.unpost"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <!--<td>
                        <v-checkbox v-model="props.item.report"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.locked"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>-->
                    <!--<td>
                        <v-checkbox v-model="props.item.unLocked"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.finished"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.delivered"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.assign"
                                    :disabled="!filters.role"
                                    @change="savePageSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>-->
                </template>
            </v-data-table>
        </v-flex>
        <!-- End Of actions table  -->
        <!-- Fields Table -->
        <v-flex xs12 v-if="1 !==1">
            <v-data-table :id="$store.getters.lang == 'ar' ?'table' :'noId'" :loading="isLoading" :headers="fieldsHeaders" :items="pageFields" class="elevation-1">
                <template slot="items" slot-scope="props">
                    <td>{{ getLabelByLang(props.item.pageENName, props.item.pageARName) }}</td>
                    <td>{{ getLabelByLang(props.item.fieldENName, props.item.fieldARName) }}</td>
                    <td>
                        <v-checkbox v-model="props.item.isShow"
                                    :disabled="!filters.role"
                                    @change="saveFieldSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox v-model="props.item.isEnable"
                                    :disabled="!filters.role"
                                    @change="saveFieldSecurity(props.item)"
                                    primary
                                    hide-details></v-checkbox>
                    </td>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import SystemService from '@/services/SystemService';
    import RoleService from '@/services/RoleService';
    import ModuleService from '@/services/ModuleService';
    import PageService from '@/services/PageService';
    import PageSecurityService from '@/services/AdminSystem/Security/PageSecurityService';
    import FieldSecurityService from '@/services/AdminSystem/Security/FieldSecurityService';

    export default {
        name: 'page-security',
        data() {
            return {
                filters: {
                    role: null,
                    system: null,
                    module: null,
                    page: null
                },
                roleList: [],
                systemList: [],
                moduleList: [],
                pageList: [],
                isLoading: false,
                actions: [],
                pageFields: []
            };
        },
        async created() {
            this.getRoles();
            this.getSystems();
            this.getModules();
            this.getPages();
            this.isLoading = true;
            await this.getPageSecurity();
            await this.getFieldSecurity();
            this.isLoading = false;
        },
        methods: {
            /* Get Operations */
            async getRoles() {
                this.roleList = (await RoleService.getRoles()).data;
            },
            async getSystems() {
                this.systemList = (await SystemService.getSystems()).data;
            },
            async getModules() {
                this.moduleList = (await ModuleService.getModules()).data;
            },
            async getPages() {
                this.pageList = (await PageService.getPages()).data;
            },
            async  filterInit() {
                this.keyword = '';
                this.filters.role = null;
                this.filters.system = null;
                this.filters.module = null;
                this.filters.page = null;
                await this.getPageSecurity();
            },
            async getPageSecurity() {
                const body = {
                    roleID: this.filters.role || 0,
                    systemCodeID: this.filters.system || 0,
                    moduleCodeID: this.filters.module || 0,
                    pageCode: this.filters.page || 0
                };
                this.actions = (await PageSecurityService.getPageSecurity(body)).data;
            },
            async getFieldSecurity() {
                const body = {
                    roleID: this.filters.role || 0,
                    systemCodeID: this.filters.system || 0,
                    moduleCodeID: this.filters.module || 0,
                    pageCodeID: this.filters.page || 0
                };
                this.pageFields = (await FieldSecurityService.getFieldSecurity(body)).data;
            },

            /* Save Operation */
            async savePageSecurity(item) {
                const pageData = { ...item, roleID: this.filters.role };
                const res = (await PageSecurityService.savePageSecurity(pageData)).data;
                this.$store.dispatch('showMessage', { text: res.message });
            },
            async saveFieldSecurity(item) {
                const res = (await FieldSecurityService.saveFieldSecurity(item)).data;
                this.$store.dispatch('showMessage', { text: res.message });
            },

            /* filter  */
            async onFilter() {
                const isValid = await this.$validator.validateAll();
                if (!isValid) return;

                await this.getPageSecurity();
                await this.getFieldSecurity();
            }
        },
        computed: {
            /* Query Tabel- coulumns name for Actions in 1st table */
            actionsHeaders() {
                return [
                    { text: this.$t('page-name'), value: 'pageName', sortable: false },
                    { text: this.$t('view'), value: 'view', sortable: false },
                    { text: this.$t('add'), value: 'add', sortable: false },
                    { text: this.$t('edit'), value: 'edit', sortable: false },
                    { text: this.$t('delete'), value: 'delete', sortable: false },
                    { text: this.$t('post'), value: 'post', sortable: false },
                    { text: this.$t('unpost'), value: 'unpost', sortable: false },
                    //{ text: this.$t('report'), value: 'report', sortable: false },
                    //{ text: this.$t('locked'), value: 'locked', sortable: false },
                    //{ text: this.$t('unLocked'), value: 'unLocked', sortable: false },
                    //{ text: this.$t('finished'), value: 'finished', sortable: false },
                    //{ text: this.$t('delivered'), value: 'delivered', sortable: false },
                    //{ text: this.$t('assign'), value: 'assign', sortable: false }
                ];
            },

            /* Query Tabel- coulumns name for Fields in 2nd table */
            fieldsHeaders() {
                return [
                    { text: this.$t('page-name'), value: 'pageName', sortable: false },
                    { text: this.$t('field-name'), value: 'fieldName', sortable: false },
                    { text: this.$t('show'), value: 'show', sortable: false },
                    { text: this.$t('is-enabled'), value: 'isEnabled', sortable: false }
                ];
            },

            modules() {
                if (!this.filters.system) return this.moduleList;

                return this.moduleList.filter(mod => mod.codeSAMASystem == this.filters.system);
            },
            pages() {
                if (!this.filters.module) return this.pageList;

                return this.pageList.filter(page => page.codeModuleID == this.filters.module);
            }
        }
    };
</script>
<style>
    #table .v-icon {
        transform: rotateY(180deg);
    }
</style>
